import { Avatar, Divider, Stack, Typography } from '@mui/material';
import { GetDocumentFile } from 'API/documents';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { useLoader } from 'Hooks/useLoader';
import { PurpleDownloadIcon, PurpleEye } from 'Images';
import { downloadFile } from 'Utils';
interface IActions {
  docId: number;
  docType: number;
  docName: string;
}
export const Actions = ({ docId, docType, docName }: IActions) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  const { isLoading, setIsLoading, loader } = useLoader(
    '20',
    { width: '180px' },
    20,
    false
  );

  const documentDownloadHandler = async () => {
    setIsLoading(true);
    const documentFile = await GetDocumentFile(docType, docId);
    if (documentFile?.contentBase64)
      downloadFile(documentFile.contentBase64, 'pdf', docName);
    setIsLoading(false);
  };

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='24px'
      sx={{
        width: 'fit-content',
      }}
    >
      {isLoading ? (
        loader
      ) : (
        <>
          <Stack
            direction='row'
            gap='6px'
            sx={{
              ':hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
            }}
            tabIndex={0}
            onClick={documentDownloadHandler}
          >
            <Avatar
              alt=''
              src={PurpleDownloadIcon}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body6'>{dictionary.download}</Typography>
          </Stack>
          {/* <Divider
            orientation='vertical'
            sx={{ borderColor: '#A6ACBC', height: '16px' }}
          /> */}
          {/* <Stack
            direction='row'
            gap='6px'
            sx={{
              ':hover': {
                cursor: 'pointer',
                textDecoration: 'underline',
              },
            }}
            tabIndex={0}
          >
            <Avatar
              alt=''
              src={PurpleEye}
              sx={{ width: '20px', height: '20px' }}
            />
            <Typography variant='body6'>{dictionary.watch}</Typography>
          </Stack> */}
        </>
      )}
    </Stack>
  );
};
